import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createAuthToken } from '#src/lib/auth';
import { logger } from '#src/lib/logger';
import {
  selectAuthOrProspectUser,
  selectAuthToken,
} from '#src/store/session/selectors';
import { setAuthToken } from '#src/store/session/actions';

export function useAuthToken() {
  const authToken = useSelector(selectAuthToken);
  const dispatch = useDispatch();
  const user = useSelector(selectAuthOrProspectUser);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading || authToken) return;

    setIsLoading(true);

    (async () => {
      try {
        const token = await createAuthToken(user);
        dispatch(setAuthToken(token));
      } catch (e) {
        logger.error(`[useAuthToken] ${e.message}`, { e });
        setError(true);
      }
      setIsLoading(false);
    })();
  }, [authToken, dispatch, user, isLoading]);

  return {
    authToken,
    error,
    isLoading,
  };
}
